package org.zest.insan_360_website.pages.user.main_layout

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Height
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaListCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaPerson
import com.varabyte.kobweb.silk.components.icons.fa.FaWpforms
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.dom.Div
import org.zest.insan_360_website.components.layouts.PageContentBaseCol
import org.zest.insan_360_website.components.layouts.userDashWordLibrary
import org.zest.insan_360_website.components.widgets.CreditStatsContainer
import org.zest.insan_360_website.components.widgets.StatContainer
import org.zest.insan_360_website.components.widgets.StatsSection
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.adminDataStats

val adminMainDashContentLayout = CssStyle {
    base {
        Modifier
            .grid {
                columns { repeat(2) { size(1.fr) } }
                rows { repeat(2) { size(1.fr) } }
            }
    }
    Breakpoint.XL {
        Modifier
            .grid {
                rows { size(1.fr) }
                columns { repeat(3) { size(1.fr) } }
            }
    }
}

@Composable
fun AdminLayout() {
    PageContentBaseCol(Modifier.userSelect(UserSelect.None)) {
        Div(
            adminMainDashContentLayout
                .toModifier()
                .fillMaxWidth()
                .gap(1.cssRem)
                .toAttrs()
        ) {
            StatContainer(
                userDashWordLibrary.org_member.localized,
                adminDataStats?.totalStud.toString()
            ) { FaPerson(size = IconSize.LG) }
            StatContainer(
                userDashWordLibrary.test_taken.localized,
                adminDataStats?.totalTestSub.toString()
            ) { FaWpforms(size = IconSize.LG) }
            StatContainer(
                userDashWordLibrary.test_need_verify.localized,
                adminDataStats?.totalNeedVerify.toString()
            ) { FaListCheck(size = IconSize.LG) }
        }
        CreditStatsContainer(
            Modifier.height(Height.FitContent),
            userDashWordLibrary.org_credit_info.localized,
            StatsSection(
                "${userDashWordLibrary.org_credit.localized} : ",
                adminDataStats?.creditStats?.total.toString()
            ),
            StatsSection(
                "${userDashWordLibrary.active.localized} : ",
                adminDataStats?.creditStats?.active.toString()
            ),
            StatsSection(
                "${userDashWordLibrary.used.localized} : ",
                adminDataStats?.creditStats?.used.toString()
            ),
            StatsSection(
                "${userDashWordLibrary.expired.localized} : ",
                adminDataStats?.creditStats?.expired.toString()
            ),
            StatsSection(
                "${userDashWordLibrary.unassigned.localized} : ",
                adminDataStats?.creditStats?.active?.minus(adminDataStats?.creditStats?.assigned ?: 0).toString()
            )
        )
    }
}

